const BNB = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10" cy="10" r="10" fill="#FFC331" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.81932 8.69658L10 5.51589L13.1807 8.69658L15.0296 6.84764L10 1.81802L4.97038 6.84764L6.81932 8.69658ZM3.66539 8.1564L1.8186 10.0032L3.66539 11.85L5.51218 10.0032L3.66539 8.1564ZM10 14.489L6.81932 11.3083L4.97038 13.1572L10 18.1869L15.0296 13.1572L13.1807 11.3083L10 14.489ZM16.3351 8.15668L14.4883 10.0035L16.3351 11.8503L18.1819 10.0035L16.3351 8.15668ZM10.001 8.12769L11.8758 10.0025L10.001 11.8773L8.12616 10.0025L8.4494 9.66632L8.61749 9.51116L10.001 8.12769Z"
      fill="white"
    />
  </svg>
);
export default BNB;
